/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
==========================================================================================*/

import MsButton from "@/components/msbutton/msButton.vue";
import MsSplitButton from "@/components/msbutton/msSplitButton.vue";
import MsInput from "@/components/msinput/msInput.vue";
import MsCheckbox from "@/components/mscheckbox/msCheckbox.vue";
import MsRadio from "@/components/msradio/msRadio.vue";
import JpRadio from "@/components/msradio/jpRadio.vue";
import MsRadioGroup from "@/components/msradio/MsRadioGroup.vue";
import MsDatepicker from "@/components/msdatepicker/MsDatePicker.vue";
import MsDateRange from "@/components/msdaterange/MsDateRange.vue";
import JPDateRange from "@/components/jpdaterange/JpDateRange.vue";
import MsTextarea from "@/components/msTextarea/MsTextarea.vue";
import MsNumber from "@/components/msnumber/msNumber.vue";
import MsDropDown from "@/components/msdropdown/msDropdown.vue";
import MsDropDownMenu from "@/components/msdropdown/msDropDownMenu.vue";
import MsDropdownItem from "@/components/msdropdown/msDropdownItem.vue";
import MsPopup from "@/components/mspopup/MsPopup.vue";
import MsComboBox from "@/components/mscombobox/msCombobox.vue";
import MsComboBoxDropdown from "@/components/mscomboboxmultiple/MsComboBoxDropdownMulti.vue";
import MsInputMulti from "@/components/msinputmulti/MsInputMulti.vue";

export function registerComponents(app) {
  app.component(MsButton.name, MsButton);
  app.component(MsSplitButton.name, MsSplitButton);
  app.component(MsInput.name, MsInput);
  app.component(MsCheckbox.name, MsCheckbox);
  app.component(MsRadio.name, MsRadio);
  app.component(JpRadio.name, JpRadio);
  app.component(MsRadioGroup.name, MsRadioGroup);
  app.component(MsDatepicker.name, MsDatepicker);
  app.component(MsDateRange.name, MsDateRange);
  app.component(JPDateRange.name, JPDateRange);
  app.component(MsTextarea.name, MsTextarea);
  app.component(MsNumber.name, MsNumber);
  app.component(MsDropDown.name, MsDropDown);
  app.component(MsDropDownMenu.name, MsDropDownMenu);
  app.component(MsDropdownItem.name, MsDropdownItem);
  //Ông popup thì sẽ không cấy trực tiếp vào form mà xử lý show động
  app.component(MsPopup.name, MsPopup);
  app.component(MsComboBox.name, MsComboBox);
  app.component(MsComboBoxDropdown.name, MsComboBoxDropdown);
  app.component(MsInputMulti.name, MsInputMulti);
}
